// Общее для ручек ассетов (персонажи, локации, предметы — api/assets.ts): тексты кодов проверки фото, разбор ошибки
// с контрактом detail={code,message} и multipart-POST.
//
// С 02.10 персонажи — страницы как у Artlist (/characters, api/assets.ts); прежний клиент сборки персонажа из фото
// (эталон, студийный набор, лист, «Сохранить») ушёл вместе с модалом кабинета — его ручки на бэке остались для
// старых вкладок, фронт их не зовёт.

const API_BASE = import.meta.env.VITE_API_URL || ''

// Тексты кодов проверки и записи фото (одна запись фото на бэке — characters._store_photo_file).
export const PHOTO_ERROR_TEXTS: Record<string, string> = {
	TOO_LARGE: 'Файл до 15 МБ',
	BAD_TYPE: 'Только JPG, PNG или WebP',
	CORRUPT: 'Файл повреждён — не удалось прочитать изображение',
	TOO_SMALL: 'Минимум 512px по меньшей стороне',
	TOO_BIG: 'Максимум 8000px по большей стороне',
	SERVER_IMAGING: 'На сервере не установлена обработка изображений — сообщите администратору',
	S3_WRITE_FAILED: 'Хранилище файлов не приняло фото — сообщите администратору',
	DB_WRITE_FAILED: 'База данных не приняла запись — сообщите администратору',
}

/** Ошибка ручки с контрактом detail={code,message} → текст для человека: словарь кодов, затем message бэка. */
export function apiErrorText(e: unknown, texts: Record<string, string>): string {
	const detail = (e as { detail?: { code?: string; message?: string } })?.detail
	if (detail?.code && texts[detail.code]) return texts[detail.code]
	if (detail?.message) return detail.message
	if (e instanceof Error && e.message) {
		// Сетевые/парс-сбои (рестарт бэка → 502 с пустым телом, обрыв сети)
		// нельзя показывать юзеру сырьём вроде «Unexpected end of JSON input».
		if (/JSON|Failed to fetch|NetworkError|Load failed/i.test(e.message)) {
			return 'Сервер перезапускается или недоступен — попробуйте через минуту'
		}
		return e.message
	}
	return 'Что-то пошло не так. Попробуйте ещё раз'
}

/** multipart-POST (api.request JSON-ит тело): Bearer, ошибка — объект ответа (detail={code,message}). */
export async function postForm<T>(path: string, fd: FormData): Promise<T> {
	const token = localStorage.getItem('token')
	const res = await fetch(`${API_BASE}${path}`, {
		method: 'POST',
		headers: token ? { Authorization: `Bearer ${token}` } : {},
		body: fd,
	})
	const json = await res.json().catch(() => ({}))
	if (!res.ok) throw json
	return json as T
}
